// extracted by mini-css-extract-plugin
export var buttons = "_b8-0";
export var buttonsActive = "_b8-h";
export var cancelConfirm = "_b8-1";
export var closeButton = "_b8-2";
export var column = "_b8-3";
export var container = "_b8-4";
export var detailHeader = "_b8-6";
export var detailTitle = "_b8-7";
export var detailsContent = "_b8-5";
export var header = "_b8-8";
export var headerWithClose = "_b8-9";
export var icon = "_b8-a";
export var infoIcon = "_b8-c";
export var informationContainer = "_b8-b";
export var sideDrawer = "_b8-d";
export var sideDrawerOpen = "_b8-e";
export var stickyFooter = "_b8-f";
export var typeOption = "_b8-g";